import React, {ChangeEvent} from "react";
import {AppApi} from "../../../../utils/AppApi";
import {useAlert} from "../../../../utils/components/providers/AlertProvider";
import {Utils} from "../../../../utils/Utils";
import {MemberRegion} from "./MemberRegions";

export default function EditMemberRegions(params: {
    show: boolean, region: MemberRegion, close: (region?: MemberRegion) => void
}) {
    const {showMessage} = useAlert()
    const [region, setRegion] = React.useState(params.region)

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
        setRegion({...region, [event.target.name]: event.target.value})
    }

    const saveMembershipType = () => {
        Utils.toggleSpinner('show')
        AppApi.saveMemberRegion({regionId: region.regionId, regionName  : region.regionName.trim(),})
            .then(res => {
                Utils.toggleSpinner('hide')
                if (res.data.success) {
                    params.close({...region, regionId: res.data['regionId']})
                } else {
                    showMessage({message: res.data.message, type: 'error'})
                }
            })
            .catch(() => {
                Utils.toggleSpinner('hide')
                showMessage({message: 'Error saving member region, please retry', type: 'error'})
            })
    }

    React.useEffect(() => {
        setRegion(params.region)
    }, [params.region])

    return (
        <div className={`modal_container ${params.show ? 'show' : ''}`.trim()}>
            <div className="modal_body">
                <h6 className="mb-4">{params.region.regionId === "" ? 'Add Member Region' : 'Edit Member Region'}</h6>

                <form method="post">
                    <div className="mb-3">
                        <label htmlFor="regionName" className="form-label">Region Name</label>
                        <input type="text" className="form-control" id="regionName" name="regionName"
                               value={region.regionName} onChange={handleChange} required/>
                    </div>
                </form>

                <div className={'form_buttons'}>
                    <div className={'row m-0'}>
                        <div className={'col-6 ps-0 pe-1'}>
                            <button type="button" className="btn btn-secondary" onClick={() => params.close()}>Close Window</button>
                        </div>
                        <div className={'col-6 ps-1 pe-0'}>
                            <button type="button" className="btn btn-primary" onClick={saveMembershipType}>Save Data</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}